import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { updateEmailAddress } from '../../constants/emails.consts'
import { openEmailClient } from '../../utils/openEmailClient.utils'
import {
    Container,
    ButtonWrapper,
    CurrentEmailAddress,
    DeleteButton,
    Email,
    EmailAddress,
    RightIcon
} from './DeleteOrChangeEmailSection.style'
import FlexContainer from '../style/FlexContainer.style'
import Drawer from '@components/Drawer/Drawer.component'
import DeleteAccount from '@components/DeleteAccount/DeleteAccount.component'

interface Props {
    email: string
}

const DeleteOrChangeEmailSection: FC<Props> = ({ email }) => {
    const { t } = useTranslation()

    const [modalOpen, setModalOpen] = React.useState(false)

    return (
        <>
            <Container>
                <div>
                    <FlexContainer justifycontent="space-between" marginbottom="16px">
                        <EmailAddress>{t('profile.email')}</EmailAddress>
                        <RightIcon
                            className="wemolo-edit minor-hover-effect"
                            onClick={() => {
                                openEmailClient(updateEmailAddress)
                            }}
                        />
                    </FlexContainer>
                    <CurrentEmailAddress>{t('profile.email')}</CurrentEmailAddress>
                    <Email>{email}</Email>
                </div>
            </Container>
            <ButtonWrapper>
                <DeleteButton
                    onClick={() => {
                        setModalOpen(true)
                    }}
                >
                    <i className="wemolo-ico-trash" />
                    <span>{t('profile.delete.title')}</span>
                </DeleteButton>
            </ButtonWrapper>
            <Drawer
                isOpen={modalOpen}
                onClose={() => {
                    setModalOpen(false)
                }}
                content={<DeleteAccount />}
            />
        </>
    )
}

export default DeleteOrChangeEmailSection
